import baseAPI from "@/http";

const router = "api/municipio/membro";

export const membrosApi = {
  getMembroByMunicipio: (municipioId) =>
    baseAPI.get(`${router}/get-membro-by-municipio/${municipioId}`),
};
